import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatCurrency } from 'common/constants/currency';
import { formatCPF } from 'utils/formatters';
import { OnlineContractingStateMapping } from 'v3/data/store/onlineContracting/mapping';
import { OnlineContractingType } from 'v3/data/store/onlineContracting/types';
import { RoutesEnum } from 'v3/routes/enum';
import PaymentStatusIcon from 'v3/shared/components/CircleIcon';
import { SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';
import {
  AlignClientInfo,
  AlignValues,
  BodyLine,
  HeaderLine,
  Line,
  MainContainer,
  SeeMoreContainer,
  StatusContainer,
  StatusTitle,
  SubtitleLine,
} from '../styles';

interface IMobileTable {
  contractingList: OnlineContractingType[];
}

export const OnlineContractingMobileTable: React.FC<IMobileTable> = ({ contractingList }) => {
  const navigate = useNavigate();

  const handleNavigation = (contracting: OnlineContractingType) => {
    navigate(`${RoutesEnum.ContractingInApp}/${contracting.contractingKey}`);
  };

  return (
    <Fragment>
      {contractingList.map((contracting) => {
        const { fullName, cpf } = contracting.person;
        const formattedCPF = formatCPF(cpf);
        const { vtexPaymentId } = contracting.creditSimulation;

        const contractingStatusTitle =
          OnlineContractingStateMapping[contracting.status]?.title || 'Status desconhecido';

        return (
          <MainContainer key={contracting.contractingKey} onClick={() => handleNavigation(contracting)}>
            <AlignValues>
              <HeaderLine>Id de Pagamento</HeaderLine>
              <AlignClientInfo>
                <BodyLine className="empty-line">{vtexPaymentId ? vtexPaymentId : ''}</BodyLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Cliente</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{fullName}</BodyLine>
                <SubtitleLine>{formattedCPF}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Valor Financiado</HeaderLine>
              <AlignClientInfo>
                <BodyLine className="empty-line">
                  {contracting.creditSimulation.financing?.requestedAmount
                    ? formatCurrency(contracting.creditSimulation.financing.requestedAmount)
                    : ''}
                </BodyLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Canal</HeaderLine>
              <AlignClientInfo>
                <BodyLine>DimoFinancing</BodyLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Status</HeaderLine>
              <AlignClientInfo>
                <StatusContainer>
                  <PaymentStatusIcon></PaymentStatusIcon>
                  <StatusTitle>{contractingStatusTitle}</StatusTitle>
                </StatusContainer>
              </AlignClientInfo>
            </AlignValues>
            <Line />
            <SeeMoreContainer>
              <SubtitleMediumBold>Ver mais</SubtitleMediumBold>
              <ArrowForwardIosIcon />
            </SeeMoreContainer>
          </MainContainer>
        );
      })}
    </Fragment>
  );
};
